import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { ApiQueryParams } from '@/pages/OperationsInsights/types/ApiQueryParams';
import { ApiRespBacklogMetricsByBuckets } from '@/pages/OperationsInsights/types/BacklogMetricsResponse';
import { transformDateIntoLocalString } from '@/utils';

/**
 * Fetch In, Out, Open backlogs by buckets
 *
 * @param params
 */
export const fetchBacklogMetricsByBuckets = async (params: ApiQueryParams): Promise<ApiRespBacklogMetricsByBuckets> => {
    const fromDate = transformDateIntoLocalString(params.fromDate);
    const toDate = transformDateIntoLocalString(params.toDate);
    const fetchUrl =
        '/workactivity/back-office/backlog/snapshot/buckets?' +
        `fromDate=${fromDate}&toDate=${toDate}&workstreamDefinitionIds=${params.workstreamDefinitionIds.join(',')}`;
    const resp: ApiRespBacklogMetricsByBuckets = await fetchFromLambda(fetchUrl);

    // initialise date
    if (resp.metrics?.length) {
        resp.metrics.forEach((metric) => {
            metric.bucket = new Date(metric.bucket);
        });
        resp.metrics.sort((a, b) => a.bucket.getTime() - b.bucket.getTime());

        // Enrichment (local calculation for closedWithinSLA)
        let previousOpenCount: null | number = null;
        resp.metrics.forEach((metric) => {
            metric.closedWithinSLA = metric.closedCount - metric.closedBreached;
            if (previousOpenCount !== null) {
                metric.openCountChanges = metric.openCount - previousOpenCount;
            }
            previousOpenCount = metric.openCount;
        });
    }
    return resp as ApiRespBacklogMetricsByBuckets;
};
